export const REASSIGN_PROJECT_GROUP = 'REASSIGN_PROJECT_GROUP';
export const REASSIGN_PROJECT_GROUP_RESPONSE = 'REASSIGN_PROJECT_GROUP_RESPONSE';